<template>
  <main
    id="stock"
    class="page-container stock-index"
    v-if="$route.name === 'listini'"
  >
    <section class="cards-grid-stock">
      <router-link
        v-for="cat in categories"
        :key="cat.slug"
        :to="`/home/listini/${cat.slug}`"
        class="card-stock"
        :aria-label="cat.label"
      >
        <span class="icon-wrap">
          <i :class="cat.icon" aria-hidden="true"></i>
        </span>
        <span class="label">{{ cat.label }}</span>
      </router-link>
    </section>
  </main>
  <router-view />
</template>

<script>
export default {
  name: "ListiniPage",
  data() {
    return {
      categories: [
        {
          slug: "piastrelle",
          label: "Piastrelle",
          icon: "fa-solid fa-border-all",
        },
        // {
        //   slug: "rivestimenti parete",
        //   label: "Rivestimenti Parete",
        //   icon: "fa-solid fa-paint-roller",
        // },
        // {
        //   slug: "parquet",
        //   label: "Parquet",
        //   icon: "fa-solid fa-grip-horizontal",
        // },
        // {
        //   slug: "laminati",
        //   label: "Laminati",
        //   icon: "fa-solid fa-layer-group",
        // },
        // {
        //   slug: "decking esterno",
        //   label: "Decking Esterno",
        //   icon: "fa-solid fa-tree",
        // },
        // { slug: "box doccia", label: "Box Doccia", icon: "fa-solid fa-shower" },
        // { slug: "sanitari", label: "Sanitari", icon: "fa-solid fa-toilet" },
        // {
        //   slug: "rubinetteria",
        //   label: "Rubinetteria",
        //   icon: "fa-solid fa-faucet",
        // },
        // {
        //   slug: "accessori bagno",
        //   label: "Accessori Bagno",
        //   icon: "fa-solid fa-bath",
        // },
        // { slug: "profili", label: "Profili", icon: "fa-solid fa-minus" },
        // {
        //   slug: "sistemi di scarico",
        //   label: "Sistemi di Scarico",
        //   icon: "fa-solid fa-water",
        // },
        // { slug: "mobili", label: "Mobili", icon: "fa-solid fa-couch" },
        // {
        //   slug: "porte e infissi",
        //   label: "Porte e Infissi",
        //   icon: "fa-solid fa-door-open",
        // },
        // { slug: "altro", label: "Altro", icon: "fa-solid fa-box" },
      ],
    };
  },
};
</script>

<style src="@/css/StockPage.css" />
